import { IFlightSearchBarState } from './state';

export enum FlightSearchBarActionType {
  SET_START_DATE = 'SetStartDate',
  SET_END_DATE = 'SetEndDate',
  SET_GUESTS = 'SetGuests',
  SET_ARRIVAL_AIRPORT = 'SetArrivalAirport',
  SET_DEPARTURE_AIRPORT = 'SetDepartureAirport',
  SET_IS_ONE_WAY = 'SetIsOneWay',
  SET_IS_DIRECT_FLIGHT = 'SetIsDirectFlight',
  SET_IS_VALID_FLIGHT_SEARCH_BAR = 'SetIsValidFlightSearchBar',
  SET_IS_SUBMIT = 'SetIsSubmit',
  SET_CABIN_CLASS = 'SetCabinClass',
}

export interface SetStartDate {
  type: FlightSearchBarActionType.SET_START_DATE;
  payload: IFlightSearchBarState['startDate'];
}

export interface SetEndDate {
  type: FlightSearchBarActionType.SET_END_DATE;
  payload: IFlightSearchBarState['endDate'];
}

export interface SetGuests {
  type: FlightSearchBarActionType.SET_GUESTS;
  payload: IFlightSearchBarState['guestInfo'];
}

export interface SetArrivalAirport {
  type: FlightSearchBarActionType.SET_ARRIVAL_AIRPORT;
  payload: IFlightSearchBarState['arrivalAirport'];
}

export interface SetDepartureAirport {
  type: FlightSearchBarActionType.SET_DEPARTURE_AIRPORT;
  payload: IFlightSearchBarState['departureAirport'];
}

export interface SetIsOneWay {
  type: FlightSearchBarActionType.SET_IS_ONE_WAY;
  payload: IFlightSearchBarState['isOneWay'];
}

export interface SetIsDirectFlight {
  type: FlightSearchBarActionType.SET_IS_DIRECT_FLIGHT;
  payload: IFlightSearchBarState['isDirectFlight'];
}

export interface SetIsValidFlightSearchBar {
  type: FlightSearchBarActionType.SET_IS_VALID_FLIGHT_SEARCH_BAR;
  payload: IFlightSearchBarState['isValidFlightSearchBar'];
}

export interface SetIsSubmit {
  type: FlightSearchBarActionType.SET_IS_SUBMIT;
  payload: IFlightSearchBarState['isSubmit'];
}
export interface SetCabinClass {
  type: FlightSearchBarActionType.SET_CABIN_CLASS;
  payload: IFlightSearchBarState['cabinClass'];
}

export type FlightSearchBarActions =
  | SetStartDate
  | SetEndDate
  | SetGuests
  | SetArrivalAirport
  | SetDepartureAirport
  | SetIsOneWay
  | SetIsDirectFlight
  | SetIsValidFlightSearchBar
  | SetIsSubmit
  | SetCabinClass;
